import React,{Component} from 'react';
import {connect} from "react-redux"
import {bindActionCreators} from "redux"
import {Link} from 'react-router-dom'

import * as reportsActions from '../../../actions/reportsActions'


class Reports extends Component{
    constructor(props){
        super(props);
        this.getReports();
    }
    getReports(){
        let {reportsActions} = this.props;
        reportsActions.Get()
    }
    render(){
        let {reports,companies} = this.props;
        return(
            <React.Fragment>
                <div className="content reports-page">
                    <div className="table-wrapp">
                        <div className="datatable-header">
                            <div className="controls">
                                <div className="left-controls"></div>
                                <div className="right-controls">
                                    <Link to={"/admin/report/0"} className="btn btn-success">
                                        <i className="glyphicon glyphicon-plus"></i> Добавить отчет
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>id</th>
                                        <th>Название</th>
                                        <th>Компания</th>
                                        <th>Конкуренты</th>
                                        <th>Время начала</th>
                                        <th>Статус</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        reports.data.map((elem,index)=>{
                                            let {consolidatedReportSettings} = elem;

                                            let startHour = consolidatedReportSettings.startHour != null? consolidatedReportSettings.startHour.toString() : "0";
                                            let startMinute = consolidatedReportSettings.startMinute != null ? consolidatedReportSettings.startMinute.toString() : "0";
                                            if(startHour.length < 2){
                                                startHour = "0" + startHour;
                                            }
                                            if(startMinute.length < 2){
                                                startMinute = "0" + startMinute;
                                            }
                                            let startTime = `${startHour}:${startMinute}`

                                            let opponents = consolidatedReportSettings.bindings.map((item)=>{ return " "+ item.companyName })



                                            return(
                                                <tr key={index} onClick={(e)=> this.props.history.push(`/admin/report/${elem.id}`)} title="Редактировать">
                                                    <td>{elem.id}</td>
                                                    <td>{elem.name}</td>
                                                    <td>{consolidatedReportSettings.companyName}</td>
                                                    <td dangerouslySetInnerHTML={{__html:opponents}}>{}</td>
                                                    <td>{startTime}</td>
                                                    <td>{
                                                        elem.isActive?
                                                            <span className="label label-success">активный</span>
                                                            :
                                                            <span className="label label-default">неактивный</span>
                                                    }</td>
                                                </tr>
                                            )
                                        })
                                    }

                                </tbody>
                            </table>
                        </div>

                        <div className="datatable-footer"></div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}


function mapStateToProps(state) {
    return{
        reports:state.reports,
        companies:state.companies
    }
}

function mapDispatchToProps(dispatch) {
    return{
        reportsActions:bindActionCreators(reportsActions,dispatch)
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Reports);


// WEBPACK FOOTER //
// ./src/components/Admin/Reports/index.jsx